import {Component , OnInit , OnDestroy} from '@angular/core';
import {FormControl , FormGroup} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {BlogService} from '../../../../core/services/blog.service';
import {ActivatedRoute , Router} from '@angular/router';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {TargetGroupService} from '../../../../core/services/targetGroup.service';
import {ToastrService } from 'ngx-toastr';
import {FrontUserService} from '../../../../core/services/frontUsers.service';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {BlogTypeService} from '../../../../core/services/blogType.service';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {FuseConfigService} from '../../../../core/services/config.service';
import { RecommendedEventModal } from '../../events/recommend-event-modal/recommend-event.component';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { SubscriptionService } from '../../../../core/services/subscription.service';

@Component({
    selector: 'blog-detail',
    templateUrl: './blog-detail.html',
    styleUrls: ['./blog-detail.scss', './../custom-blog/new-blog.component.scss'],
    standalone: false
})

export class BlogDetailComponent implements OnInit , OnDestroy {
  public editorConfig = {
    placeholder: ''
  };
  public info = {
    title: '' ,
    text: '' ,
    link: '' ,
    linkLabel: '' ,
    image: '' ,
    video: '' ,
    header: '' ,
    fullText: '' ,
    fullTitle: '' ,
    dateFrom: '' ,
    dateTo: '' ,
    type: '' ,
    date: 0 ,
    visible: '' ,
    targetGroup: [] ,
    tag: [] ,
    userRole: [],
    blogTypeId: '',
    recommendButton: false,
    canRemoveRecommendation: false,
    recommendationCreated: false,
    recommendationId: null,
    userId: null,
    editable: false,
    unsubscribe: false
  };
  public opacityColor;
  public videoUrl;
  public blogForm: FormGroup = new FormGroup({
    title: new FormControl('') ,
    fullTitle: new FormControl('') ,
    text: new FormControl('') ,
    fullText: new FormControl('') ,
    link: new FormControl('') ,
    linkLabel: new FormControl('') ,
    image: new FormControl('') ,
    video: new FormControl('') ,
    header: new FormControl('') ,
    id: new FormControl('') ,
    dateFrom: new FormControl('') ,
    dateTo: new FormControl('') ,
    type: new FormControl('') ,
    visible: new FormControl('') ,
    targetGroup: new FormControl('') ,
    userRole: new FormControl('') ,
    tag: new FormControl(''),
    blogTypeId: new FormControl(''),
    lang: new FormControl('')
  });
  id;
  public uploadedImg = null;
  public uploadedImg2 = null;
  public radio = 'small';
  public config = {
    editable: true ,
    spellcheck: true ,
    height: 'auto' ,
    minHeight: '150px' ,
    width: 'auto' ,
    minWidth: '0' ,
    translate: 'yes' ,
    enableToolbar: true ,
    showToolbar: true ,
    placeholder: 'Enter text here...' ,
    imageEndPoint: '' ,
    toolbar: [
      [ 'bold' , 'italic' , 'underline' , 'strikeThrough' , 'superscript' , 'subscript' ] ,
      [ 'fontSize' ] ,
      [ 'justifyLeft' , 'justifyCenter' , 'justifyRight' , 'justifyFull' , 'indent' , 'outdent' ] ,
      [ 'delete' , 'removeFormat' ] ,
      [ 'paragraph' , 'blockquote' , 'removeBlockquote' , 'horizontalLine' , 'orderedList' , 'unorderedList' ]
    ]
  };
  public targetGroups = [];
  frontRoles = [];
  tags = [];
  array;
  category = [];
  public subscription = new Subscription();
  platforms;
  selectedPlatforms = [];
  userId;

  constructor (private _sanitizer: DomSanitizer , private route: ActivatedRoute , private router: Router ,
               public blogService: BlogService , public dialog: MatDialog , public targetService: TargetGroupService , public toastr: ToastrService  ,
               public frontUser: FrontUserService, public blogType: BlogTypeService,
               private platformsService: PlatformsService, private fuseConfig: FuseConfigService,
               public translate: TranslateService, private location: Location,
               private subscriptionService: SubscriptionService) {
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.subscription.add(this.blogService.getBlogById(this.id).subscribe((res: any) => {
      let _info = res;
      if (_info.targetGroup) {
        _info.targetGroup = _info.targetGroup.split(',').map(el => +el);
      }
      if (_info.tag) {
        _info.tag = _info.tag.split(',').map(el => +el);
      }
      if (_info.userRole) {
        _info.userRole = _info.userRole.split(',').map(el => +el);
      }
      if (_info.platforms) {
        let plat = _info.platforms.split(',');
        this.selectedPlatforms = plat.map(el => Number(el.replace(/\//g, '')));
      }
      this.info = _info;
      this.blogForm.patchValue(_info);
    }));
    this.fuseConfig.organizationId.subscribe((res) => {
      if (res) {
        let organizationId = parseInt(res, 10);
        this.platformsService.getByOrganizationId(organizationId).subscribe(platforms => {
          this.platforms = platforms;
          if (this.platforms && this.platforms.length === 1) {
            this.changePlatforms({value: [this.platforms[0].id]});
          }
        });
      }
    });
    this.fuseConfig.userId.subscribe((res) => {
      if (res) {
        this.userId = res;
      }
    });
    this.subscription.add(this.fuseConfig.role.subscribe(res => {
      if (res && res === 'superAdmin') {
        this.getPlatforms();
      }
    }));
  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res && res.length) {
        this.platforms = res;
        if (this.platforms && this.platforms.length === 1) {
          this.changePlatforms({value: [this.platforms[0].id]});
        }
      }
    });
  }

  changePlatforms(platform) {
    this.selectedPlatforms = platform.value;
  }

  ngOnInit () {
    this.getTargetGroups();
    this.getUserRole();
    this.getTags();
    this.getBlogType();
    this.subscription.add(this.blogForm.valueChanges.subscribe(data => {
      if (!data.image && this.uploadedImg) {
        delete data.image;
      }
      this.info = Object.assign({} , this.info , data);
      if (this.info.video) {
        if (this.info.video.indexOf('embed') !== -1) {
          this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.info.video
          );
        } else {
          this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.parseYoutube(this.info.video)
          );
        }
      } else {
        this.videoUrl = '';
      }
    }));
    this.opacityColor = this.hexToRGB('#FFFFFF' , 0.3);
  }

  getTargetGroups () {
    this.targetService.targetGroupsGroped().subscribe((data: any) => {
      this.targetGroups = data.targetGroups;
    });
  }

  getUserRole () {
    this.frontUser.getRoles().subscribe((data: any) => {
      this.frontRoles = data;
    });
  }

  getTags () {
    this.frontUser.listTags().subscribe((data: any) => {
      this.tags = data;
    });
  }

  getBlogType () {
    this.blogType.getBlogTypeDropDown().subscribe((data: any) => {
      this.category = data;
    });
  }

  hexToRGB (hex , alpha) {
    const r = parseInt(hex.slice(1 , 3) , 16) ,
      g = parseInt(hex.slice(3 , 5) , 16) ,
      b = parseInt(hex.slice(5 , 7) , 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  setImg (img) {
    this.uploadedImg = img;
    this.uploadedImg2 = img;
    const reader = new FileReader();
    const that = this;
    reader.onload = function (e) {
      const res: any = e;
      that.info.image = res.target.result;
    };
    reader.readAsDataURL(this.uploadedImg);
  }

  selectBlog (e) {
    this.radio = e;
  }

  deleteBlog () {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscription.add(this.blogService.deleteBlog(this.id).subscribe((res) => {
          this.toastr.success('Blog deleted' , 'Success!');
          this.router.navigate([ './pages/blog' ]);
        }));
      }
    });
  }

  parseYoutube (url) {
    let link = 'https://www.youtube.com/embed/';
    const videoId = url.split('?v=');
    link = link + videoId[ 1 ];
    return link;
  }


  updateBlog () {
    console.log(this.blogForm.value);
    const data = this.blogForm.value;
    if (data.visible === 'public') {
      delete data.targetGroup;
    }
    if (this.selectedPlatforms && this.selectedPlatforms.length) {
      let platforms = this.selectedPlatforms.map(el => '/' + el.toString() + '/');
      data.platforms = platforms;
    }
    data.file = this.uploadedImg2;
    this.subscription.add(this.blogService.addBlog(data).subscribe((res) => {
      if (res) {
        this.toastr.success('Blog updated' , 'Success!');
        this.router.navigate([ './pages/blog' ]);
      }
    }));
  }

  closePicker(event, data) {
    let res = data.datepickerInput.value;
    if (res) {
      if (event === 'dateFrom') {
        this.blogForm.patchValue({dateFrom: moment(res).format('DD.MM.YYYY')});
      }
      if (event === 'dateTo') {
        this.blogForm.patchValue({dateTo: moment(res).format('DD.MM.YYYY')});
      }
    }
  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

  setAll (name, i) {
    console.log(name);
    this.array = (this.blogForm.get('targetGroup').value && this.blogForm.get('targetGroup').value.length ) ? this.blogForm.get('targetGroup').value : [];
    console.log(this.array , 'aard');
    for (let i = 0; i < this.targetGroups.length; i++) {
      console.log(this.targetGroups[ i ].name);
      if (this.targetGroups[ i ].name === name) {
        console.log(true);
        let arr = [];
        let arrForPush = [];
        arr = (this.blogForm.get('targetGroup').value && this.blogForm.get('targetGroup').value.length) ? this.blogForm.get('targetGroup').value : [];
        let count = 0;
        for (let j = 0; j < this.targetGroups[ i ].data.length; j++) {
          console.log(this.targetGroups[ i ].data[ j ]);
          let index = this.array.indexOf(this.targetGroups[ i ].data[ j ].id);
          if (index !== -1) {
            arr.splice(index , 1);
            count++;
            arrForPush.push(this.targetGroups[ i ].data[ j ].id);
          } else {
            arr.push(this.targetGroups[ i ].data[ j ].id);
          }
        }
        if (count === this.targetGroups[ i ].data.length) {
          this.array = Array.from(arr);
        } else {
          arrForPush.forEach((item) => {
            arr.push(item);
          });
          this.array = Array.from(arr);
        }
      }
    }
    if (this.targetGroups[ i ].data && this.targetGroups[ i ].data[ 0 ] && this.array.includes(this.targetGroups[ i ].data[ 0 ].id)) {
      this.targetGroups[ i ].selected = true;
    } else {
      this.targetGroups[ i ].selected = false;
    }
    console.log(this.array , 'aard');
    this.blogForm.patchValue({targetGroup: this.array});
  }

  createRecommendation() {
    const dialogRef = this.dialog.open(RecommendedEventModal , {
      width: '500px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          blogId: this.id,
          recommendation_text: result
        };
        this.blogService.addRecommendation(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_created');
            this.toastr.success(msg, title);
            this.info.recommendationCreated = true;
            this.info.canRemoveRecommendation = true;
            this.info.recommendationId = res.id;
          }
        });
      }
    });
  }

  removeRecommendation() {
    let title = this.translate.instant('event.remove_recommendation');
    let msg = this.translate.instant('event.remove_recommendation_confirm');
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: title , message: msg}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.blogService.removeRecommendation(this.info.recommendationId).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_removed');
            this.toastr.success(msg, title);
            this.info.recommendationCreated = false;
            delete this.info.recommendationId;
          }
        });
      }
    });
  }


  goBack() {
    this.location.back();
  }

  unsubscribeBlog() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'blog.unsubscribe' , message: 'blog.unsubscribe_question'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptionService.deleteBlogSubscription(this.id).subscribe((res: any) => {
          this.goBack();
        })
      }
    });
  }
}
